// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2B1LK","colMaxWidth":"Table_colMaxWidth__bzT9J"};